import * as types from '../mutation-types'
import { unionState } from '../union-state'

export default {
    namespaced: true,

    state: {
        manufacturingBonds: [],
        manufacturingBond: {},
        entries: [],
        entry: {},
        rawMaterials: [],
    },

    /* eslint-disable no-unused-vars */
    actions: {
        // bonds actions
        fetchAll({ commit }, { fromDate, toDate, postingStatus } ){
            return window.axios.get('manufacturing', {
                params: {
                    fromDate, toDate, postingStatus
                    /* postingStatus: NotDefined => 0, Posted => 1, NotPosted => 2, All => 3 */
                }
            })
            .then(response => {
                commit(types.STORE_MANUFACTURING_BONDS, response.data);
                return response.data;
            });
        },

        fetchById({ commit }, { manufacturingFileId }){
            return window.axios.get(`manufacturing/${manufacturingFileId }`)
            .then(response => {
                commit(types.STORE_ONE_MANUFACTURING_BOND, response.data);
                return response.data;
            });
        },

        create({ commit }, { date }){
            return window.axios.post('manufacturing', { date })
            .then(response => {
                return response.data;
            });
        },

        delete({ commit }, { manufacturingFileId }){
            return window.axios.delete(`manufacturing/${manufacturingFileId }`)
            .then(response => {
                return response.data;
            });
        },

        updateToPosted({ commit }, { manufacturingFileId }){
            return window.axios.put(`manufacturing/${manufacturingFileId}/changeToPosted`)
            .then(response => {
                return response.data;
            });
        },

        updateToNotPosted({ commit }, { manufacturingFileId }){
            return window.axios.put(`manufacturing/${manufacturingFileId}/changeToNotPosted`)
            .then(response => {
                return response.data;
            });
        },

        // entries actions
        fetchAllEntries({ commit }, { manufacturingFileId }){
            return window.axios.get(`manufacturing/${manufacturingFileId}/entries`)
            .then(response => {
                commit(types.STORE_MANUFACTURING_ENTRIES, response.data);
                return response.data;
            });
        },

        fetchEntryById({ commit }, { manufacturingFileId, entryId }){
            return window.axios.get(`manufacturing/${manufacturingFileId}/entries/${entryId}`)
            .then(response => {
                commit(types.STORE_ONE_MANUFACTURING_ENTRY, response.data);
                return response.data;
            });
        },

        createEntry({ commit }, { manufacturingFileId, material_id, warehouse_id, count, quantity, unit_size_id, cost, loss_ratio }){
            return window.axios.post(`manufacturing/${manufacturingFileId}/entries`, {
                material_id, warehouse_id, count, quantity, unit_size_id, cost, loss_ratio
            })
            .then(response => {
                return response.data;
            });
        },

        updateEntry({ commit }, { manufacturingFileId, entryId, material_id, warehouse_id, count, quantity, unit_size_id, cost, loss_ratio }){
            return window.axios.put(`manufacturing/${manufacturingFileId}/entries/${entryId}`, {
                material_id, warehouse_id, count, quantity, unit_size_id, cost, loss_ratio
            })
            .then(response => {
                return response.data;
            });
        },

        deleteEntry({ commit }, { manufacturingFileId, entryId }){
            return window.axios.delete(`manufacturing/${manufacturingFileId}/entries/${entryId}`)
            .then(response => {
                return response.data;
            });
        },

        // raw materials
        fetchAllRawMaterials({ commit }, { manufacturingFileId, entryId }){
            return window.axios.get(`manufacturing/${manufacturingFileId}/entries/${entryId}/rawMaterials`)
            .then(response => {
                commit(types.STORE_MANUFACTURING_RAW_MATERIALS, response.data);
                return response.data;
            });
        },

        createRawMaterial({ commit }, { manufacturingFileId, entryId, material_id, warehouse_id, count, quantity, unit_size_id, cost, manufacturing_file_entry_id }){
            return window.axios.post(`manufacturing/${manufacturingFileId}/entries/${entryId}/rawMaterials`, {
                material_id, warehouse_id, count, quantity, unit_size_id, cost, manufacturing_file_entry_id
            })
            .then(response => {
                return response.data;
            });
        },

        updateRawMaterial({ commit }, { manufacturingFileId, entryId, rawMaterialId,  material_id, warehouse_id, count, quantity, unit_size_id, cost, manufacturing_file_entry_id }){
            return window.axios.put(`manufacturing/${manufacturingFileId}/entries/${entryId}/rawMaterials/${rawMaterialId }`, {
                material_id, warehouse_id, count, quantity, unit_size_id, cost, manufacturing_file_entry_id
            })
            .then(response => {
                return response.data;
            });
        },

        deleteRawMaterial({ commit }, { manufacturingFileId, entryId, rawMaterialId }){
            return window.axios.delete(`manufacturing/${manufacturingFileId}/entries/${entryId}/rawMaterials/${rawMaterialId }`)
            .then(response => {
                return response.data;
            });
        },

        resetRawMaterial({ commit }){
            commit(types.STORE_MANUFACTURING_RAW_MATERIALS, []);
        }
    },

    /* eslint-enable no-unused-vars */

    mutations: {
        // bonds mutations
        [types.STORE_MANUFACTURING_BONDS](state, manufacturingBonds){
            state.manufacturingBonds = manufacturingBonds;
        },

        [types.STORE_ONE_MANUFACTURING_BOND](state, manufacturingBond){
            state.manufacturingBond = manufacturingBond;
        },

        // entries mutations
        [types.STORE_MANUFACTURING_ENTRIES](state, entries){
            state.entries = entries;
        },

        [types.STORE_ONE_MANUFACTURING_ENTRY](state, entry){
            state.entry = entry;
            state.entries = unionState(state.entries, [entry]);
        },

        // raw material
        [types.STORE_MANUFACTURING_RAW_MATERIALS](state, rawMaterials){
            state.rawMaterials = rawMaterials;
        },
    },

    getters: {
        getBondById: state => id => state.manufacturingBonds.find(c => c.id === id),
        getBondByNo: state => no => state.manufacturingBonds.find(c => c.no === no),
        getEntryById: state => id => state.entries.find(c => c.id === id),
    }
}